import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { RouterModule } from '@angular/router';
import { Ng2CompleterModule } from 'ng2-completer';

import { AppComponent } from './app.component';
import { Configuration } from './app.constants';

// import { SidebarModule } from './sidebar/sidebar.module';
import { AppRoutes } from './app.routing';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { PagesnavbarModule } from './shared/pagesnavbar/pagesnavbar.module';
import { PaginatorModule } from './shared/paginator/paginator.module';

import { AuthService } from './shared/services/auth';
import { BalanceService } from './shared/services/balance';
import { BrandService } from './shared/services/brand';
import { CategoryService } from './shared/services/category';
import { CmsLabelService } from './shared/services/cms_label';
import { CountryService } from './shared/services/country';
import { CouponService } from './shared/services/coupon';
import { FaqService } from './shared/services/faq';
import { GiftService } from './shared/services/gift';
import { GlobalService } from './shared/services/global';
import { ImgService } from './shared/services/img';
import { InvoiceService } from './shared/services/invoice';
import { LanguageService } from './shared/services/language';
import { MeasureUnitService } from './shared/services/measure_unit';
import { NotificationService } from './shared/services/notifcation';
import { NotifyService } from './shared/services/notify';
import { OrderService } from './shared/services/order';
import { ProductService } from './shared/services/product';
import { ProductSetService } from './shared/services/product_set';
import { SettingService } from './shared/services/setting';
import { ShippingCostService } from './shared/services/shipping_cost';
import { SlideshowService } from './shared/services/slideshow';
import { TranslationService } from './shared/services/translation';
import { TutorialService } from './shared/services/tutorial';
import { UseTypeService } from './shared/services/use_type';
import { UserService } from './shared/services/user';
import { VariationService } from './shared/services/variation';
import { VatSystemService } from './shared/services/vat_system';

import { CKEditorModule } from 'ng2-ckeditor';

import {
  ChartCommonModule,
  LineChartModule,
  NgxChartsModule,
  PieChartModule,
} from '@swimlane/ngx-charts';
import { HeadlineModule } from './headline/headline.module';
import { ComboChartModule } from './shared/combo-chart/combo-chart.module';
import { AuthInterceptor } from './shared/interceptor/auth.interceptor';
import { MainPipeModule } from './shared/pipes/pipes.module';
import { CarrierService } from './shared/services/carrier';
import { DiscountService } from './shared/services/discount';
import { GeneralSettingService } from './shared/services/general_setting';
import { PlaylistService } from './shared/services/playlist';
import { ProvService } from './shared/services/prov';
import { ShippingZoneService } from './shared/services/shipping_zone';
import { StatisticsService } from './shared/services/statistics';
import { SurveyService } from './shared/services/survey';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes),
    HttpModule,
    HttpClientModule,
    CKEditorModule,
    FixedPluginModule,
    Ng2CompleterModule,
    PagesnavbarModule,
    PaginatorModule,
    MainPipeModule,
    NgxChartsModule,
    PieChartModule,
    LineChartModule,
    ChartCommonModule,
    ComboChartModule,
  ],
  declarations: [AppComponent, AdminLayoutComponent, AuthLayoutComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    Configuration,
    CmsLabelService,
    ShippingZoneService,
    CarrierService,
    CategoryService,
    UseTypeService,
    BalanceService,
    GeneralSettingService,
    SurveyService,
    CouponService,
    DiscountService,
    ProductService,
    GlobalService,
    VariationService,
    TutorialService,
    VatSystemService,
    ProvService,
    StatisticsService,
    ProductSetService,
    ShippingCostService,
    FaqService,
    ImgService,
    UserService,
    OrderService,
    SlideshowService,
    AuthService,
    InvoiceService,
    SettingService,
    GiftService,
    PlaylistService,
    MeasureUnitService,
    CountryService,
    BrandService,
    NotifyService,
    LanguageService,
    TranslationService,
    NotificationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
